







import Getters from '@/mixins/Getters'
import { Component, Mixins, Watch } from 'vue-property-decorator'

@Component({
  name: 'PayloadSwitch'
})
export default class PayloadSwitch extends Mixins(Getters) {
  protected isPayload: boolean = false

  // Toggle payload mode on switcher change
  @Watch('isPayload')
  protected onIsPayloadChange(value: boolean) {
    this.uiStore.commitIsPayload(value)
  }
}
